<template>
  <v-container fluid>
    <v-row>
      <v-col cols="1">
        <span>{{ $t('rtrck.title.tcod') }}</span>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <v-autocomplete name="tcod" v-model="tcod.tcod" :items="tcodList" @update:search-input="searchTcod" :label="$t('rtrck.ph.tcod')" clearable dense flat hide-no-data hide-details solo> </v-autocomplete>
        </v-toolbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { isEmpty } from 'lodash';
import { api } from '@/api/common/instances';
export default {
  props: {
    params: {},
  },
  data() {
    return {
      tcodList: [],
    };
  },
  computed: {
    ...mapState('extra/auth/role-tracker', ['tcod']),
  },
  watch: {
    'tcod.tcod': {
      handler() {
        this.tcodList = (() => {
          if (this.tcod.tcod === undefined) return [];
          else return [this.tcod.tcod];
        })();
      },
    },
  },
  methods: {
    async searchTcod(input) {
      if (input === null || input == this.tcod.tcod) return;
      this.tcodList = await this.autoSearch('tcod', { tcode: input });
      this.tcodList.unshift(isEmpty(input) ? input : input.toUpperCase());
    },
    async autoSearch(uri, params) {
      const {
        data: { items },
      } = await api.get(`/rtrck/search/auto-search/${uri}`, {
        params: {
          ...this.params,
          ...params,
        },
      });
      return items;
    },
  },
};
</script>

<style scoped>
.col-1 {
  padding-top: 10px;
}
.v-toolbar ::v-deep .v-toolbar__content {
  padding: 4px;
}
</style>
